import { ResourceType } from './resource-type';

export const CONTENT_SOURCE = new ResourceType('contentsource');
